/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoardPatient } from 'app/shared/model/tumor-board-patient.model';
import { ITumorBoardOccurrence } from 'app/shared/model/tumor-board-occurrence.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ITumorBoardOutcome {
  id?: string;
  createdById?: string | null;
  createdByType?: keyof typeof AddedByType | null;
  outcomeSummary?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  patient?: ITumorBoardPatient | null;
  occurrence?: ITumorBoardOccurrence | null;
}

export const defaultValue: Readonly<ITumorBoardOutcome> = {
  active: false,
};
